import DashBoardNav from '@/layout/DashBoardNav'

export default [{
  path: '/comprar-dados',
  component: DashBoardNav,
    children: [{
      path: '/comprar-dados',
      component: () => import('@/components/compra/comprarDados')
    }
  ]
}]
